module.exports = __webpack_public_path__ + "img/Kockduell.afdc917c.jpg";